/**
 * @fileoverview Contexto responsável por expor o controle de alternância do tema de cores.
 */

import React from "react";

const ColorModeContext = React.createContext({ toggleColorMode: () => {} });

export default ColorModeContext;
